<template>
  <div class="dialog">
    <div class="create update">
      <el-dialog :title="dialog.title" :visible.sync="dialog.visible" :close-on-click-modal="false">
        <el-form
          :ref="form.ref"
          :model="form.data"
          :label-width="form.labelWidth"
          :rules="dialog.isEdit ? form.rules.update: form.rules.create"
          auto-complete="off"
          @submit.prevent.native="handleRegister"
        >
          <slot name="dialogFormItem" :isEdit="dialog.isEdit"></slot>
        </el-form>
        <el-alert
          v-if="dialog.isAlert"
          :title="dialog.errorMessage"
          type="error"
          show-icon
          :closable="false"
        ></el-alert>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleRegister" :loading="dialog.loading">OK</el-button>
          <el-button @click="handleRegisterCancel">キャンセル</el-button>
        </span>
      </el-dialog>
    </div>

    <div class="delete">
      <el-dialog
        class="message-box"
        title="削除確認"
        :visible.sync="bulkDeleteDialog.visible"
        :close-on-click-modal="false"
        align="left"
      >
        <span>チェックしている{{ bulkDeleteDialog.idlist.length }}件のデータを削除してもよいですか？</span>
        <span slot="footer" class="dialog-footer">
          <el-alert
            v-if="bulkDeleteDialog.isAlert"
            :title="bulkDeleteDialog.errorMessage"
            type="error"
            show-icon
            :closable="false"
          ></el-alert>
          <el-button type="danger" @click="handleBulkDelete" :loading="bulkDeleteDialog.loading">はい</el-button>
          <el-button @click="bulkDeleteDialog.visible = false">いいえ</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { AdminEventBus } from "@/components/admin/EventBus";
import axios from "axios";

export default {
  props: {
    title: String,
    form: Object,
    endpointUrl: String,
    endpointBulkDeleteUrl: String
  },
  data() {
    return {
      dialog: {
        visible: false,
        title: "",
        loading: false,
        errorMessage: "",
        isAlert: false,
        isEdit: false
      },
      bulkDeleteDialog: {
        visible: false,
        loading: false,
        isAlert: false,
        errorMessage: "",
        idlist: []
      }
    };
  },
  created() {
    AdminEventBus.$on("click-new", () => {
      console.log("dialog $on");
      this.onClickNewButton();
    });
    AdminEventBus.$on("click-edit", next => {
      this.onClickEditButton(next);
    });
    AdminEventBus.$on("click-delete", idlist => {
      this.bulkDeleteDialog.idlist = idlist;
      this.onClickDeleteButton();
    });
  },
  methods: {
    resetForm: function(next) {
      this.$nextTick(() => {
        let ref = this.$refs[this.form.ref];
        if (ref !== undefined) {
          console.log(ref);
          ref.clearValidate();
          if (ref.$el[0].autofocus) {
            ref.$el[0].focus();
          }
          if (next !== undefined) {
            next();
          }
        }
      });
    },
    onClickNewButton: function() {
      this.dialog = Object.assign({}, this.dialog, {
        visible: true,
        title: this.title + "の新規追加",
        loading: false,
        errorMessage: "",
        isAlert: false,
        isEdit: false
      });
      this.resetForm(() => {
        AdminEventBus.$emit("init-form");
      });
    },
    onClickEditButton: function(next) {
      this.dialog = Object.assign({}, this.dialog, {
        visible: true,
        title: this.title + "の編集",
        loading: false,
        errorMessage: "",
        isAlert: false,
        isEdit: true
      });
      this.resetForm(next);
    },
    onClickDeleteButton: function() {
      this.bulkDeleteDialog = Object.assign({}, this.bulkDeleteDialog, {
        visible: true,
        loading: false,
        isAlert: false,
        errorMessage: ""
      });
    },
    handleRegisterCancel() {
      this.dialog = Object.assign({}, this.dialog, {
        visible: false,
        title: "",
        loading: false,
        errorMessage: "",
        isAlert: false,
        isEdit: false
      });
    },
    handleRegister() {
      this.dialog.loading = true;
      let ref = this.$refs[this.form.ref];
      let form = this.form.data;
      ref.validate(valid => {
        if (valid) {
          let request;
          if (this.dialog.isEdit) {
            let unique = 'uuid' in form ? form.uuid : form.id
            request = axios.put(`${this.endpointUrl}${unique}/`, form);
          } else {
            request = axios.post(this.endpointUrl, form);
          }
          request
            .then(() => {
              this.dialog.visible = false;
              ref.resetFields();
              AdminEventBus.$emit("refresh");
            })
            .catch(error => {
              if (error.response !== undefined) {
                this.dialog.isAlert = true;
                this.dialog.loading = false;
                if (error.response.status === 400) {
                  let e = error.response.data;
                  console.log(e);
                  if (Array.isArray(e)) {
                    this.dialog.errorMessage = e.join(",");
                  } else {
                    if ("non_field_errors" in e) {
                      this.dialog.errorMessage = e.non_field_errors.join(",");
                    } else if ("detail" in e) {
                      this.dialog.errorMessage = e.detail;
                    } else if (typeof e === "object") {
                      this.dialog.errorMessage = Object.values(e).join("");
                    } else {
                      this.dialog.errorMessage = e;
                    }
                  }
                } else {
                  this.dialog.errorMessage = "不明なエラーが発生しました。";
                }
              }
            });
          return true;
        } else {
          this.dialog.loading = false;
        }
      });
    },
    handleBulkDelete: function() {
      this.bulkDeleteDialog.loading = true;
      this.bulkDeleteDialog.errorMessage = "";
      this.bulkDeleteDialog.isAlert = false;
      axios
        .delete(this.endpointBulkDeleteUrl, {
          params: {
            id: JSON.stringify(this.bulkDeleteDialog.idlist)
          }
        })
        .then(() => {
          this.bulkDeleteDialog.visible = false;
          this.bulkDeleteDialog.isAlert = false;
          this.bulkDeleteDialog.errorMessage = "";
          this.bulkDeleteDialog.loading = false;
          AdminEventBus.$emit("refresh");
        })
        .catch(error => {
          if (error.response !== undefined) {
            this.bulkDeleteDialog.isAlert = true;
            this.bulkDeleteDialog.loading = false;
            this.bulkDeleteDialog.errorMessage = "不明なエラーが発生しました。";
          }
        });
    }
  }
};
</script>

<style scoped>
.contents-loading {
  visibility: hidden;
}
.dialog >>> .el-select {
  width: 100% !important;
}
.dialog >>> .el-select__tags {
  max-width: 100% !important;
}
</style>
